




















import { listFactory } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { filter } from '@/modules/servis/ozakazka/store/list';
import { isMultipleWorkshopSelected, getSearchButtonLabel, handleMultiWorkshopFilter, validateDateFields, getCurrentLanguageId } from '@/main/utils/commonFunctions';

import { apiProvider } from './api';

import { NAME, addThreeMonths, subtractOneDay } from './constants';
import { store } from './store/list';

export default listFactory(NAME, store).extend({
	data() {
		return {
			fromDate: 'PODateFrom',
			toDate: 'PODateTo',
		};
	},
	computed: {
		isMultipleWorkshopSelected(): boolean {
			return isMultipleWorkshopSelected(this.WorkshopIds);
		},
		searchButtonLabelKey(): string {
			return getSearchButtonLabel(this.WorkshopIds);
		},
	},
	methods: {
		viewClick(event: any) {
			openEdit(NAME, PageMode.VIEW, { id: event.data.ID });
		},
		dateValidation() {
			if (!this.PODateFrom || !this.PODateTo) {
				this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
				return false;
			}
			if (this.PODateFrom && this.PODateTo) {
				const fromDate = new Date(this.PODateFrom);
				const toDate = new Date(this.PODateTo);
				const checkDateRange = new Date(fromDate.getFullYear(), fromDate.getMonth() + addThreeMonths, fromDate.getDate() - subtractOneDay);
				if (fromDate > toDate) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('GREATER_DATE_VALIDATION') });
					this.PODateTo = null;
					return false;
				}
				if (toDate > checkDateRange) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('VALIDATION_FOR_THREE_MONTH') });
					this.PODateFrom = null;
					this.PODateTo = null;
					return false;
				}
			} else {
				return false;
			}
			return true;
		},
		async exportFun() {
			try {
				if (this.filter.WorkshopIds == null || this.filter.WorkshopIds.length === 0) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('DEALER_CODE_NOT_NULL') });
					return;
				}
				if (!this.filter.PODateFrom || !this.filter.PODateTo) {
					this.showErrorAlert({ message: this.LocalizePopisPoli('CR_DATE_VALIDATION') });
					return;
				}
				this.startLoading();
				if (this.isMultipleWorkshopSelected) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('MultiWorkshopExportDisabled'),
					});
				} else {
					await apiProvider.GetFullNonReceivedPartReport(this.filter, getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId));
				}
			} finally {
				this.endLoading();
			}
		},
		async filterClick() {
			if (!validateDateFields(this, this.fromDate, this.toDate)) {
				return;
			}
			await handleMultiWorkshopFilter(
				this,
				NAME,
				this.WorkshopIds,
				(columnsSeq) => ({
					WorkshopIds: this.WorkshopIds,
					PODateFrom: this.PODateFrom,
					PODateTo: this.PODateTo,
					ColumnSequence: columnsSeq.join(','),
					LanguageId: getCurrentLanguageId(this.loggedUser.UzivatelData.LanguageId),
				}),
			);
		},
	},
});
